// extracted by mini-css-extract-plugin
export default {"cls1":"ESgwKQz4oVzqrYFtmnK4","cls2":"AhqpnXKMgg2Zpd4uvxBl ESgwKQz4oVzqrYFtmnK4"};